import { ButtonProps } from '@stadionhq-v3/base-ui';
import { Button } from '../../button.component';

export const TertiaryButton = (props: ButtonProps) => (
  <Button variant="tertiary" {...props} />
);

export default TertiaryButton;
